import { render, staticRenderFns } from "./GridUpdated.vue?vue&type=template&id=fa020378&scoped=true"
import script from "./GridUpdated.vue?vue&type=script&lang=js"
export * from "./GridUpdated.vue?vue&type=script&lang=js"
import style0 from "./GridUpdated.vue?vue&type=style&index=0&id=fa020378&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa020378",
  null
  
)

export default component.exports